module.exports = __webpack_public_path__ + "static/6-447534ef560f8e0e72097b684c77a163.png";